import service from "@/utils/request"

export function getWxUserCountApi(params) {
    return service({
        url: '/wxUserApi/getUserCount',
        method: 'get',
        params
    })
}

export function getWxUserPageApi(params) {
    return service({
        url: '/wxUserApi/getWxUserPage',
        method: 'get',
        params
    })
}

export function updateUserScoreApi(params) {
    return service({
        url: '/wxUserApi/updateUserScore',
        method: 'get',
        params
    })
}
export function updateScoreApi(params) {
    return service({
        url: '/wxUserApi/updateScore',
        method: 'get',
        params
    })
}

export function getWxUserScoreApi(params) {
    return service({
        url: '/wxUserApi/getWxShopUserScoreList',
        method: 'get',
        params
    })
}
export function getWxScoreApi(params) {
    return service({
        url: '/wxUserApi/getWxShopScoreList',
        method: 'get',
        params
    })
}

export function updateUserLevelApi(params) {
    return service({
        url: '/wxUserApi/updateUserLevel',
        method: 'get',
        params
    })
}

export function getBindWxUserTelApi(params) {
    return service({
        url: '/wxUserApi/getBindWxUserTel',
        method: 'get',
        params
    })
}

export function exportUserExcel(params) {
    return service({
        url: '/wxUserApi/exportUserList',
        method: 'get',
        params: params,
        responseType: 'blob',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    })
}


export function updateUserAgentApi(params) {
    return service({
        url: '/wxUserApi/updateUserAgent',
        method: 'get',
        params
    })
}


export function userUnbind(params) {
    return service({
        url: '/wxUserApi/userUnbind',
        method: 'get',
        params
    })
}

export function updateUserScoreNewApi(params) {
    return service({
        url: '/wxUserApi/updateUserScoreNew',
        method: 'get',
        params
    })
}

export function updateUserMoneyNewApi(params) {
    return service({
        url: '/wxUserApi/updateUserMoneyNewApi',
        method: 'get',
        params
    })
}


export function wxUserGetFansApi(params) {
    return service({
        url: '/wxUserApi/getFans',
        method: 'get',
        params
    })
}

export function wxUserCountTodayFansApi(params) {
    return service({
        url: '/wxUserApi/countTodayFans',
        method: 'get',
        params
    })
}

export function wxUserMyAccountFansApi(params) {
    return service({
        url: '/wxUserApi/myAccount',
        method: 'get',
        params
    })
}

export function userUpdateStatusApi(params) {
    return service({
        url: '/wxUserApi/updateStatus',
        method: 'get',
        params
    })
}





